import { Navigate, Outlet } from "react-router-dom";
import ApiData from "../api/ApiData";
import { observer } from "mobx-react-lite";
import { getStoredUser } from "../utils/auth.utils";

const PrivateUserAuth = observer(() => {
  const user = getStoredUser();

  if (ApiData.isAuth && user) {
    return <Outlet />;
  }

  return <Navigate to="/login" replace />;
});

export { PrivateUserAuth };
